document.querySelectorAll('.denperm-page').forEach((root) => {
  if (root.dataset.referenceReady) return;
  root.dataset.referenceReady = 'true';
  const main = root.querySelector('.denperm-gallery-main img');
  const thumbs = [...root.querySelectorAll('[data-gallery-src]')];
  const dialog = root.querySelector('.denperm-lightbox');
  const expanded = root.querySelector('[data-gallery-expanded]');
  const count = root.querySelector('[data-gallery-count]');
  const sticky = root.querySelector('.denperm-sticky');
  const addButton = root.querySelector('.denperm-form [name="add"]');
  let scrollPending = false;
  function updateSticky() {
    sticky.hidden = addButton.getBoundingClientRect().bottom > 0;
    scrollPending = false;
  }
  function scheduleSticky() {
    if (scrollPending) return;
    scrollPending = true;
    requestAnimationFrame(updateSticky);
  }
  window.addEventListener('scroll', scheduleSticky, {passive:true});
  window.addEventListener('resize', scheduleSticky, {passive:true});
  new ResizeObserver(scheduleSticky).observe(root.querySelector('.denperm-info'));
  let index = 0;
  function show(next) {
    index = (next + thumbs.length) % thumbs.length;
    const selected = thumbs[index];
    main.src = selected.dataset.gallerySrc;
    expanded.src = selected.dataset.gallerySrc.replace('width=1100', 'width=2000');
    count.textContent = `${index + 1} / ${thumbs.length}`;
    thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb === selected)));
    root.querySelector('[data-gallery-prev]').disabled = index === 0;
    root.querySelector('[data-gallery-next]').disabled = index === thumbs.length - 1;
    const strip = selected.parentElement;
    strip.scrollTo({left: Math.max(0, selected.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + selected.clientWidth / 2), behavior: 'smooth'});
  }
  thumbs.forEach((thumb, next) => thumb.addEventListener('click', () => show(next)));
  root.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
  root.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
  root.querySelector('[data-lightbox-prev]').addEventListener('click', () => show(index - 1));
  root.querySelector('[data-lightbox-next]').addEventListener('click', () => show(index + 1));
  root.querySelector('[data-gallery-open]').addEventListener('click', () => {
    show(index);
    dialog.showModal();
    document.documentElement.classList.add('denperm-lightbox-open');
  });
  root.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {if (event.target === dialog) dialog.close();});
  dialog.addEventListener('close', () => document.documentElement.classList.remove('denperm-lightbox-open'));
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {event.preventDefault(); show(index - 1);}
    if (event.key === 'ArrowRight') {event.preventDefault(); show(index + 1);}
  });
  let touchStart;
  root.querySelector('.denperm-gallery-main').addEventListener('touchstart', (event) => {
    touchStart = {x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY};
  }, {passive: true});
  root.querySelector('.denperm-gallery-main').addEventListener('touchend', (event) => {
    if (!touchStart) return;
    const dx = event.changedTouches[0].clientX - touchStart.x;
    const dy = event.changedTouches[0].clientY - touchStart.y;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
    touchStart = null;
  }, {passive: true});
  const picker = root.querySelector('[data-sticky-bundle]');
  const fallback = root.querySelector('[data-denperm-variant]');
  const bundles = root.querySelector('.denperm-kaching');
  const purchaseTranslations = JSON.parse(root.querySelector('[data-purchase-translations]')?.textContent || '{}');
  function sync() {
    const bars = [...bundles.querySelectorAll('.kaching-bundles__bar')];
    bars.forEach((bar) => {
      const title = bar.querySelector('.kaching-bundles__bar-title');
      if (!title) return;
      const quantity = Number(title.textContent.match(/^\s*(\d+)/)?.[1]);
      const label = purchaseTranslations[{1:'one',2:'two',4:'four',8:'eight'}[quantity]];
      if (label && title.textContent !== label) title.textContent = label;
    });
    bundles.querySelectorAll('*').forEach((element) => {
      if (element.children.length) return;
      const text = element.textContent.trim();
      const replacement = {'BUNDLE & SAVE':purchaseTranslations.heading,'🎁 Complete Your Smile Kit with Free Gifts':purchaseTranslations.gifts,'FREE':purchaseTranslations.free,'Locked':purchaseTranslations.locked}[text];
      const saving = text.match(/^SAVE\s+(\d+)%$/);
      const next = replacement || (saving && purchaseTranslations.save?.replace('__percent__',saving[1]));
      if (next && next !== text) element.textContent = next;
    });
    [...bundles.querySelectorAll('.kaching-bundles__progressive-gifts__gift')].slice(2).forEach((gift) => {
      if (!gift.classList.contains('denperm-extra-gift')) gift.classList.add('denperm-extra-gift');
    });
    const labels = bars.map((bar) => bar.querySelector('.kaching-bundles__bar-title')?.textContent.trim() || '');
    if (bars.length && labels.every(Boolean)) {
      const signature = labels.join('|');
      if (picker.dataset.signature !== signature) {
        picker.replaceChildren(...labels.map((label, i) => new Option(label, String(i))));
        picker.dataset.signature = signature;
      }
      const selected = bars.findIndex((bar) => bar.classList.contains('kaching-bundles__bar--selected'));
      if (selected >= 0) picker.value = String(selected);
    } else if (!bars.length && picker.dataset.signature) {
      picker.replaceChildren(...[...fallback.options].map((option) => new Option(option.textContent, option.value)));
      delete picker.dataset.signature;
    }
    const compare = root.querySelector('[data-denperm-compare]');
    const saving = root.querySelector('[data-denperm-saving]');
    const stickyCompare = root.querySelector('[data-denperm-sticky-compare]');
    const stickySaving = root.querySelector('[data-denperm-sticky-saving]');
    stickyCompare.textContent = compare.textContent;
    stickyCompare.hidden = compare.hidden;
    stickySaving.textContent = saving.textContent;
    stickySaving.hidden = saving.hidden;
  }
  picker.addEventListener('change', () => {
    const bars = [...bundles.querySelectorAll('.kaching-bundles__bar')];
    if (bars.length) bars[Number(picker.value)]?.querySelector('input[type="radio"]')?.click();
    else {fallback.value = picker.value; fallback.dispatchEvent(new Event('change', {bubbles:true}));}
    requestAnimationFrame(sync);
  });
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {pending=false;sync();});
  }).observe(bundles, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  root.querySelector('[data-denperm-variant]').addEventListener('change', sync);
  show(0);
  sync();
  updateSticky();
});
